import { SegmentId } from '../../utils/segments';

export type SegmentFilters = {
  createdFrom?: string;
  createdTo?: string;
  categories?: number[];
  products?: string[];
  contractNumbers?: string[];
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
};

/**
 * Preserve segment-specific filters when switching between segments.
 */
class SegmentFilterManager {
  private static instance: SegmentFilterManager;
  private segmentFilters: Record<SegmentId, SegmentFilters>;

  private constructor() {
    this.segmentFilters = {
      main: {},
      bank: {},
      insurance: {},
      other: {},
    };
  }

  public static getInstance(): SegmentFilterManager {
    if (!SegmentFilterManager.instance) {
      SegmentFilterManager.instance = new SegmentFilterManager();
    }
    return SegmentFilterManager.instance;
  }

  public saveFilters(segmentId: SegmentId, filters: SegmentFilters): void {
    this.segmentFilters[segmentId] = { ...filters };
  }

  public getFilters(segmentId: SegmentId): SegmentFilters {
    return { ...this.segmentFilters[segmentId] };
  }

  public clearFilters(segmentId: SegmentId): void {
    this.segmentFilters[segmentId] = {};
  }
}

export default SegmentFilterManager;
